export default {
  neutrals: {
    charcoal: {
      base: '#323232',
      light: '#595959',
      dark: '#000000',
    },
    ash: {
      base: '#A6A6A6',
      light: '#D3D3D3',
      dark: '#808080',
    },
    silver: {
      base: '#F1F1F1',
      light: '#FAFAFA',
      dark: '#E7E7E7',
    },
    lavenderWhispers: {
      base: '#F7F5FC',
      light: '#FBFAFF',
      dark: '#F1EEFA',
    },
    white: {
      base: '#FFFFFF',
    },
  },
  main: {
    grapePurchase: {
      base: '#602D6C',
      light: '#91609C',
      dark: '#4B2354',
    },
    rx: {
      base: '#F23466',
      light: '#FF6B9C',
      dark: '#CC2D52',
    },
    genie: {
      base: '#4C18F3',
      light: '#7855D9',
      dark: '#42199A',
    },
  },
  accent: {
    savvyCyan: {
      base: '#0998D6',
      light: '#66CCFF',
      dark: '#0074A6',
    },
    tealBreaker: {
      base: '#00CCCD',
      light: '#00E0D1',
      dark: '#00BDBD',
    },
  },
  secondary: {
    dealEnvy: {
      base: '#14A382',
      light: '#00CDAD',
      dark: '#268068',
    },
    flashPink: {
      base: '#DF206C',
      light: '#E665A1',
      dark: '#B81D5B',
    },
    cyberMango: {
      base: '#EB663D',
      light: '#FA9F5A',
      dark: '#C74E30',
    },
    goldMine: {
      base: '#F5A623',
      light: '#FFC761',
      dark: '#CC861D',
    },
    fireSale: {
      base: '#EA4545',
      light: '#F16667',
      dark: '#CC3B3B',
    },
  },
  alert: {
    error: {
      base: '#CC3B3B',
    },
    success: {
      base: '#268068',
    },
  },
  rx: {
    purple: {
      base: '#A678B5',
    },
  },
};
